"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriberDto = void 0;
class SubscriberDto {
    _id;
    _organizationId;
    _environmentId;
    firstName;
    lastName;
    email;
    phone;
    avatar;
    locale;
    subscriberId;
    channels;
    deleted;
    createdAt;
    updatedAt;
    lastOnlineAt;
}
exports.SubscriberDto = SubscriberDto;
//# sourceMappingURL=subscriber.dto.js.map